import { slugify } from "../../utils/slugify.js";
import type { Chromosome } from "../Chromosome.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { Manufacturer } from "../Manufacturer.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getChromosomeSearchManufacturerPath(
	tenant: Tenant,
	manufacturer: Manufacturer,
	chromosome: Chromosome | null,
): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: `/vyhledat-produkty-dle-chromozomu/${slugify(manufacturer.name[Locale.cs])}${chromosome !== null ? `?chromosome=${chromosome}` : ""}`,
	};

	return getPathInLocale(tenant.locale, pathMap);
}
